import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf
} from '@angular/core';

//import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
//import { InMemoryDataService } from '../core/in-memory-data.service';

import { HttpConfigInterceptor } from './httpconfig.interceptor';
import { MedicalRecordService } from './manage-medical-record/medical-record.service';
import { RequestService } from './manage-request/request.service';
import { UserService } from './manage-user/user.service';
import { ManageLogService } from './manage-log/manage-log.service';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,

    //InMemoryWebApiModule.forRoot(InMemoryDataService, { delay: 600 })
  ],
  providers: [
    MedicalRecordService,
    RequestService,
    UserService,
    ManageLogService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ]
})
export class ServiceModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ServiceModule
    };
  }

  constructor(
    @Optional()
    @SkipSelf()
    parentModule: ServiceModule
  ) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
